var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-288660ac]:hover{text-decoration:underline\n}\n.heart[data-v-288660ac]{text-align:left\n}\n.heart[data-v-288660ac]:before{content:\"\";display:inline-block;width:20px;height:20px;margin-right:3px;margin-top:-1px;background:url(" + escape(require("./img/heart.png")) + ") no-repeat;background-size:100%;vertical-align:text-top\n}", ""]);

// exports
